import LayoutAnonymous from './LayoutAnonymous';

export default LayoutAnonymous;
